import { format } from 'date-fns';

import { titleByTimeWindow } from '@occc-app/routes/Audience/constants';
import { readableDate } from '@occc-app/lib/format';
import { DateTimeFormat } from '@occc-app/lib/date';
import { PeriodValues } from '@occc-app/routes/Audience/types';

const DATE_FORMAT = DateTimeFormat.DateTime12h;

export const getTimePeriodText = ({
  timeWindow,
  relativeMonthsBack,
  targetMonth,
  targetYear,
  startDate,
  endDate,
}: PeriodValues): string => {
  if (timeWindow) {
    return titleByTimeWindow[timeWindow];
  }

  if (targetMonth && targetYear) {
    return format(new Date(targetYear, targetMonth - 1, 1), 'MMMM yyyy');
  }

  if (startDate && endDate) {
    return `${readableDate(startDate, DATE_FORMAT)} - ${readableDate(endDate, DATE_FORMAT)}`;
  }

  if (relativeMonthsBack === 1) {
    return 'Previous Month';
  }

  return 'All Time';
};
